/**
 * The app's own mark, not a rebuild of it.
 *
 * The site used to draw an approximation of the logo in CSS — a bordered square
 * with a letter in it — which read as a different mark to anyone arriving from
 * the mobile app. /icon.png is byte-identical to the artwork the React Native
 * build ships as its launcher icon, so every surface now shows the same thing.
 *
 * The mark fills only ~0.59 of the artwork; the rest is black padding baked
 * into the image. So it is scaled up inside a fixed box — the box keeps the
 * layout the old borders held, and the overspill is black on black. 1.615 is
 * the point at which the V's tip starts to clip, so 1.5 leaves room for
 * antialiasing.
 *
 * Because the black field is part of the artwork, on a light surface this
 * reads as a black tile carrying the gold mark — which is exactly how the
 * icon appears on a phone home screen.
 */
const BrandMark = ({ className = '', scale = 1.5 }) => (
  <span className={`block overflow-hidden flex-shrink-0 ${className}`}>
    <img
      src="/icon.png"
      alt=""
      aria-hidden="true"
      className="w-full h-full object-cover"
      style={{ transform: `scale(${scale})` }}
    />
  </span>
);

export default BrandMark;
